import React from 'react';
import { CtaButton } from './CtaButton';
const pillars = ['Sesiones.', 'Ejercicios.', 'Progresiones.', 'Gestión.', 'Todo organizado.'];
export function FinalCta() {
  return <section className="w-full bg-court-950 py-20 text-white" aria-labelledby="final-cta-title" data-id="element-63" data-mp="19ez2tgggle3r">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-64" data-mp="15ddjbc9f61kl">
        <h2 id="final-cta-title" className="font-display text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl" data-id="element-65" data-mp="15c2fjcfz4tth">
          Deja de improvisar.
          <span className="block text-ball" data-id="element-66" data-mp="1ed8yrta0ciqf">Empieza a entrenar con un sistema.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-court-600" data-id="element-67" data-mp="1t1mznynv5x4c">
          Únete a cientos de entrenadores en todo el mundo que ya planifican su temporada completa
          en menos de 5 minutos.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-3 gap-y-2 text-[11px] font-bold uppercase tracking-[0.16em] text-court-600" data-id="element-68" data-mp="221jtsft0vo6s">
          {pillars.map(pillar => <li key={pillar} className="after:ml-3 after:text-court-700 after:content-['/'] last:after:content-['']" data-id="element-69" data-mp="n75q22s3ex8e">
              {pillar}
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-court-800 bg-court-900 p-8 sm:p-10" data-id="element-70" data-mp="x2z9850bhoz5">
          <p className="font-display text-xl font-black leading-tight tracking-tight sm:text-2xl" data-id="element-71" data-mp="123wmc36gzsts">
            🏆 Paquete Completo
            <span className="block" data-id="element-72" data-mp="162dxqywxbph0">TENIS 360™ — 12 Volúmenes + 6 Bonos</span>
          </p>
          <p className="mt-6 flex flex-wrap items-center justify-center gap-4" data-id="element-73" data-mp="1b1qk7ijvuuj2">
            <span className="text-lg text-court-600 line-through" data-id="element-74" data-mp="1fvkyg6gpyhar">$318</span>
            <span className="font-display text-5xl font-black leading-none text-ball" data-id="element-75" data-mp="1ktmhire5agm8">$19</span>
            <span className="rounded-full bg-ball px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-court-950" data-id="element-76" data-mp="1pszdq2qwp01h">
              Ahorras $299
            </span>
          </p>
          <div className="mt-9" data-id="element-77" data-mp="3qufgxynvg0wd">
            <CtaButton className="w-full sm:w-auto" data-id="element-78" data-mp="3qvqj5u1o50ld">🎾 Sí, quiero mi Tenis 360 ahora</CtaButton>
            <p className="mt-4 text-xs text-court-600" data-id="element-79" data-mp="3lwneiaplowdx">
              🔒 Pago Seguro · ⚡ Acceso Inmediato · 🛡️ Garantía de 7 Días
            </p>
          </div>
        </div>
      </div>
    </section>;
}